module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.759ea19b.woff";